/*tslint:disable:ban-types*/
import * as React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { Location } from "history";

class PreventLossData extends React.Component<IInnerProps & IProps> {
  defaultMessage = "Wyjście spowoduje utratę danych. Czy jesteś pewien?";
  // eslint-disable-next-line no-new-func
  unblock = new Function();

  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(props: IInnerProps & IProps) {
    super(props);
  }

  shouldComponentUpdate(nextProps: IInnerProps & IProps) {
    return nextProps.location.pathname !== this.props.location.pathname;
  }

  render() {
    return null;
  }

  componentDidMount() {
    window.addEventListener("beforeunload", this.handleBeforeunload);
    this.unblock = this.props.history.block((location) => {
      if (!!this.props.when && this.props.when(location)) {
        return this.props.message ?? this.defaultMessage;
      }
    });
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.handleBeforeunload);
    this.unblock();
    this.props.onRedirect && this.props.onRedirect();
  }

  handleBeforeunload = (e: BeforeUnloadEvent) => {
    e.returnValue = this.props.message ?? this.defaultMessage;
  };
}

interface IProps {
  when?: (nextLocation: Location) => boolean;
  message?: string;
  onRedirect?: () => void;
}

interface IInnerProps extends RouteComponentProps {}

export default withRouter(PreventLossData);
